import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { hit } from "./metrika";

export default function MetrikaTracker() {
  const location = useLocation();
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    if (location.pathname.startsWith("/cv/print")) return;
    hit(location.pathname + location.search);
  }, [location]);

  return null;
}
